import { INTERACTIVE_PRODUCT_TYPE } from '../../constants/interactive-product-type';
import isInteractiveStandaloneMaterial from './is-interactive-standalone-material';

const getInteractiveProductType = (item: Material) => {
    let type;

    if (item.interactiveId || item.isBundleInteractive) {
        if (isInteractiveStandaloneMaterial(item)) {
            type = INTERACTIVE_PRODUCT_TYPE.STANDALONE;
        } else {
            type = INTERACTIVE_PRODUCT_TYPE.HYBRID;
        }
    }

    return type;
};

export default getInteractiveProductType;
